import Group666 from '../assets/landing.png';
import Group567 from '../assets/Group567.png';
import Group601 from '../assets/Group601.png';
import Vector from '../assets/Vector.png';
import Vector1 from '../assets/Vector1.png';
import { FaFire } from "react-icons/fa";
import Group638 from '../assets/Group638.png';
import Group652 from '../assets/Group652.png';
import Frame from '../assets/Frame.png';
import Group610 from '../assets/Group610.png';
import Group609 from '../assets/Group609.png';
import Group608 from '../assets/Group608.png';
import Group607 from '../assets/Group607.png';
import Group691 from '../assets/Group691.png';
import Search from '../assets/Search.png';
import Group692 from '../assets/Group692.png';
import Footer from '../components/Footer';
import Faqs from '../components/Faqs';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const CreditReport = () => {
    
    const [scoreBar, setScoreBar] = useState(0);
    const [cursorStyle, setCursorStyle] = useState({
        left: 0,
        top: 0,
    });

    useEffect(() => {
        getCenterPosition(1);
        window.addEventListener('resize',()=> getCenterPosition(1));
    }, []);

    const getCenterPosition = (index) => {
        const targetDiv = document.getElementById(`scorebar-${index}`);
        if(targetDiv){
            const rect = targetDiv.getBoundingClientRect();
            setScoreBar(index);
            const centerX = rect.left + rect.width / 2 - 40;
            //const centerY = rect.top + rect.height / 2;
            setCursorStyle({
                left: centerX + 'px',
                //top: centerY + 'px',
            });
        }
    };

    return (
        
        <div className='max-md:flex max-md:flex-col overflow-x-hidden font-sans' >
            
            <div className='gradientdiv flex flex-col md:flex-row lg:flex-row w-full lg:h-dvh md:p-6 p-2 mt-16 md:mt-10'>
                <div className='flex flex-col md:w-[80%] lg:w-[60%] w-full md:p-[8%] lg:p-[8%] p-[5%] lg:pt-[10%]'>
                    <p className='text-2xl md:text-5xl mb-5 md:leading-normal max-md:order-1 max-md:mt-2'>Instantly Know<br />
                        Your <span className='text-primary'> CIBIL Score for Free</span></p>
                    <p className='text-text_color1 w-[full] mb-5 max-md:order-4 max-md:mt-8'>Lorem ipsum dolor sit amet consectetur. Gravida tortor augue dolor aliquet cursus.
                        Neque sagittis in nibh neque dui quam ac dignissim risus.Lorem ipsum dolor sit amet consectetur.
                        Gravida tortor augue dolor aliquet cursus. Neque sagittis in nibh neque dui quam ac dignissim risus.</p>
                    <Link to='/profile' className='flex max-md:order-3 w-full max-md:justify-center'><button className='bg-primary hover:text-gray-200 rounded-xl md:w-[30%] lg:w-[30%] w-[60%] md:h-14 h-12 px-3 md:mt-3 mt-6 text-white max-md:self-center max-md:text-xs'>Get Free Cibil Score</button></Link>
                    <div className='md:hidden flex justify-center items-center max-md:order-2 max-md:h-60 max-md:w-60 max-md:self-center max-md:translate-x-2 max-md:my-2'>
                        <img className='object-cover'src={Group666} alt='none' height={500} width={500} />
                    </div>
                </div>
                <div className='max-md:hidden flex justify-center items-center max-lg:w-72'>
                    <img src={Group666} alt='none' height={500} width={500} />
                </div>
                
            </div>
            <p className='text-2xl max-md:w-[60%] max-md:self-center md:text-4xl text-center mt-10 md:mt-[5%]'><span className='text-primary'>Benefits</span> of good CIBIL score</p>
            <div className='flex flex-col justify-center items-center w-full'>

                <p className='text-center text-text_color1 md:mx-[20%] lg:mx-[20%] mx-[10%] mt-5 max-md:text-md'>Your CIBIL Score is a 3-digit record computed by using details found in the 'Accounts' and 'Enquiries'
                    sections on your CIBIL Report. Banks and other Commercial lenders use credit score to quickly assess the risk
                    associated with lending money to a particular individual.</p>

                <div className='max-md:grid max-md:grid-cols-2 max-md:gap-4 max-md:p-4 flex md:gap-10 lg:gap-10 gap:5 mt-[3%] md:w-[90%] lg:w-auto'>
                    <div className='flex-col md:w-[30%] h-auto shadow-lg rounded-lg flex justify-center items-start p-5'>
                        <div className='max-md:w-10'><img className='object-cover' src={Group567} alt="none" width={50} height={50} /></div>
                        <p className='font-bold md:text-xl mt-2'>Free CIBIL Score Access</p>
                    </div>
                    <div className='flex-col md:w-[30%] h-auto shadow-lg rounded-lg flex justify-center items-start p-5'>
                        <div className='max-md:w-10'><img className='object-cover' src={Vector} alt="none" width={50} height={50} /></div>
                        <p className='font-bold md:text-xl mt-2'>Cost-Free
                            Access</p>
                    </div>
                    <div className='flex-col md:w-[30%] h-auto shadow-lg rounded-lg flex justify-center items-start p-5'>
                        <div className='max-md:w-10'><img className='object-cover mb-2' src={Group601} alt="none" width={50} height={50} /></div>
                        <p className='font-bold md:text-xl mt-2'>Credit
                            Monitoring</p>
                    </div>
                    <div className='flex-col md:w-[30%] h-auto shadow-lg rounded-lg flex justify-center items-start p-5'>
                        <div className='max-md:w-10'><img className='object-cover' src={Vector1} alt="none" width={50} height={50} /></div>
                        <p className='font-bold md:text-xl w-10 mt-2'>Personalized
                            Insights</p>
                    </div>

                </div>


            </div>
            <p className='text-2xl max-md:w-[80%] max-md:self-center md:text-4xl text-center md:mt-[5%] mt-20'><span className='text-primary'>Understanding</span> of good CIBIL score</p>
            <div className='flex flex-col justify-center items-center lineargradient1 w-full h-auto p-[2%]'>

                <p className='md:w-[50%] lg:w-[50%] w-[90%] text-justify text-text_color1 max-md:my-2 max-md:order-1'>Your CIBIL Score is a 3-digit record computed by using details found in the
                    'Accounts' and 'Enquiries' sections on your CIBIL Report. Banks and other Commercial lenders use credit score to
                    quickly assess the risk associated with lending money to a particular individual.
                </p>
                <Link to='/profile' className='w-full flex justify-center items-center'><button className='bg-primary hover:text-gray-200 rounded-lg md:w-[20%] lg:w-[16%] w-[50%] md:h-14 h-12 max-md:text-xs px-3 md:mt-10 max-md:mb-20 text-white max-md:order-4'>Get Free Cibil Score</button></Link>
                
                
                <div className='relative flex w-full justify-center items-center max-md:order-2 max-md:mt-4'>
                {scoreBar===0 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>300-660</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-red-500'>POOR</p><FaFire className='text-red-500' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                {scoreBar===1 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>660-714</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-primary'>AVERAGE</p><FaFire className='text-primary' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                {scoreBar===2 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>714-752</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-text_color2'>GOOD</p><FaFire className='text-text_color2' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                {scoreBar===3 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>752-778</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-text_color3'>VERY GOOD</p><FaFire className='text-text_color3' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                {scoreBar===4 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>778-900</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-text_color4'>EXCELLENT</p><FaFire className='text-text_color4' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                {scoreBar===5 && <div id='contentDiv' className='bg-white h-32 md:h-[25%] md:w-[40%] lg:w-[40%] w-[85%] flex flex-col items-center justify-center p-4 md:px-[4%] md:py-[1%] mt-[5%] md:rounded-lg rounded-xl'>
                    <p className='font-bold'>300-660</p>
                    <div className='flex justify-center items-center gap-2 max-md:text-sm max-md:mb-2'> <p className='text-red-500'>POOR</p><FaFire className='text-red-500' /></div>
                    <p className='text-text_color1 max-md:text-xs max-md:text-center'>It’s easy for you to get a loan with the best rates possible.
                        Services that check credit scores will have high expectations from you.</p>
                        
                </div>}

                    

                    <div id='cursorDiv' className='absolute h-4 w-4 max-md:ml-4 -bottom-1 md:-bottom-2 md:h-5 md:w-5 mt-3 transform rotate-45 bg-white text-white' style={cursorStyle}>''</div>
                </div>


                <div className='flex w-full justify-center items-center gap-0.5 ml-[-1%] mt-4 md:mt-8 max-md:mb-10 max-md:order-3'>
                    <div className='w-[20%] md:w-[16%]  cursor-pointer' onMouseEnter={()=>getCenterPosition(0)}>
                        <div id='scorebar-0' className='bg-red-500 h-3 rounded-l-md' />
                        <p className='max-md:text-xs'>300</p>
                    </div>
                    <div className='w-[14%] md:w-[8%] cursor-pointer' onMouseEnter={()=>getCenterPosition(1)}>
                        <div id='scorebar-1' className='bg-primary h-3'/>
                        <p className='max-md:text-xs'>660</p>
                    </div>
                    
                    <div className='w-[14%] md:w-[6%] cursor-pointer' onMouseEnter={()=>getCenterPosition(2)}>
                        <div id='scorebar-2' className='bg-text_color2  h-3' />
                        <p className='max-md:text-xs'>714</p>
                    </div>
                    
                    <div className='w-[14%] md:w-[6%] cursor-pointer' onMouseEnter={()=>getCenterPosition(3)}>
                        <div id='scorebar-3' className='bg-text_color3 h-3' />
                        <p className='max-md:text-xs'>752</p>
                    </div>

                    <div className='w-[18%] md:w-[6%] cursor-pointer' onMouseEnter={()=>getCenterPosition(4)} >
                        <div id='scorebar-4' className='bg-text_color4 h-3 rounded-r-md'/>
                        <span className='flex justify-between max-md:text-xs'><p>778</p>
                        <p className='object-right max-md:text-xs'>900</p></span>
                    </div>

                    
                </div>

                <p className='mt-10 max-md:mb-4 md:mt-[15%] text-2xl md:text-5xl mb-[3%] max-md:order-5'><span className='text-primary'>How</span> to Use</p>
                
                <div className='flex max-md:flex-col w-[95%] md:w-full lg:ml-[36%] md:h-[200px] lg:gap-3 gap-2 max-md:mb-32 max-md:order-6'>
                    <div className='flex max-md:justify-between max-md:items-center md:flex-col lg:w-[30%] rounded-lg justify-center max-md:gap-4 items-start bg-white shadow-lg max-md:px-4 max-md:py-8'>
                        <div className='ml-2 md:ml-[15%] md:w-[60%] max-md:w-[40%]'> <img src={Group638} alt=" none" width={60} height={60} className='md:mb-3' /></div>
                        <div className='flex md:w-[60%] md:ml-[15%] md:justify-center justify-around max-md:gap-1 items-center'>
                            <p className='text-4xl font-bold text-text_color5 md:mr-5'>01.</p>
                            <p className='max-md:text-sm max-md:font-semibold max-md:text-balance'>Start by adding your name and PAN to get CIBIL score</p>
                        </div>
                    </div>

                    <div className='flex max-md:justify-between max-md:items-center md:flex-col lg:w-[30%] rounded-lg justify-center max-md:gap-4 items-start bg-white shadow-lg max-md:px-4 max-md:py-8'>
                        <div className='ml-2 md:ml-[15%] md:w-[60%] max-md:w-[40%]'> <img src={Group652} alt=" none" width={60} height={60} className='md:mb-3' /></div>
                        <div className='flex md:ml-[15%] md:w-[60%] md:justify-center justify-around max-md:gap-1 items-center'>
                            <p className='text-4xl font-bold text-text_color5 md:mr-5'>02.</p>
                            <p className='max-md:text-sm max-md:font-semibold max-md:text-balance'>Your CIBIL score and report will appear on the dashboard</p>
                        </div>
                    </div>
                </div>
            </div>

            <p className='mt-20 md:mt-[10%] text-3xl md:text-5xl mb-[3%] text-center'><span className='text-primary max-md:text-4xl'>Tips To </span>Improve Your CIBIL Score</p>
            
            <div className='flex flex-col md:flex-row lg:flex-row w-full justify-center items-center md:ml-[5%] max-md:my-4'>
                <div className='max-md:w-[60%]'><img src={Frame} alt="none" width={350} height={350} /></div>
                <div className='flex flex-col justify-center items-center md:w-[50%] lg:w-[50%] w-[90%] mt-10 md:mt-20'>
                    <div className='flex gap-5 justify-start items-start md:w-[50%] lg:w-[50%] w-[90%]'>
                        <img src={Group610} alt="none" width={50} height={50} className='mb-6' />
                        <p className='text-text_color1'>Pay credit cards and loan
                            EMIs on time.</p>
                    </div>
                    <div className='flex gap-5 justify-start items-start md:w-[50%] lg:w-[50%] w-[90%]'>
                        <img src={Group609} alt="none" width={50} height={50} className='mb-6' />
                        <p className='text-text_color1'>Maintain 30% or lower utilization.</p>
                    </div>
                    <div className='flex gap-5  justify-start items-start md:w-[50%] lg:w-[50%] w-[90%]'>
                        <img src={Group608} alt="none" width={50} height={50} className='mb-6' />
                        <p className='text-text_color1'>Avoid multiple loan and card
                            applications.</p>
                    </div>
                    <div className='flex gap-5  justify-start items-start md:w-[50%] lg:w-[50%] w-[90%]'>
                        <img src={Group607} alt="none" width={50} height={50} className='mb-6' />
                        <p className='text-text_color1'>Check reports often for errors.</p>
                    </div>
                </div>
            </div>

            <div className='bg-text_color6  w-full h-auto mt-[8%]'>
                <div className='flex md:flex-row lg:flex-row flex-col justify-center items-center max-md:mb-8'>
                    <div className='flex flex-col m-[5%] md:w-[40%] lg:w-[40%] gap-10 max-md:mt-10 max-md:items-center'>
                        <p className='text-3xl md:text-4xl md:w-[50%] lg:w-[50%] w-[90%] max-md:text-center'><span className='text-primary text-4xl'>Factors Making</span>  Up
                            CIBIL Score</p>
                        <p className='text-text_color1 max-md:text-center'>Lorem ipsum dolor sit amet consectetur. Nullam donec non vestibulum mauris nibh egestas placerat. Et neque rhoncus gravida ipsum scelerisque adipiscing erat pellentesque. Commodo quis neque mi dignissim. Risus commodo feugiat porttitor turpis vel tortor aliquet ut.    </p>
                    </div>
                    <div className='flex flex-col gap-4 md:gap-5 m-[5%]'>
                        <div className='max-md:grid max-md:grid-cols-2 max-md:gap-4 md:flex gap-5'>
                            <div className='max-md:h-32 flex flex-col md:w-[180px] md:h-[130px] bg-white rounded-xl justify-center items-start p-6 md:p-10 gap-2'>
                                <img className='object-cover' src={Group691} alt="none" width={40} height={40} />
                                <p className='max-md:text-sm'>Credit Utilization</p>
                            </div>
                            <div className='max-md:h-32 flex flex-col md:my-[3%] md:mt-[5%] md:w-[200px] md:h-[150px] bg-white rounded-xl justify-center items-start p-6 md:p-10 gap-2'>
                                <img className='object-cover' src={Search} alt="none" width={30} height={30} />
                                <p className='max-md:text-sm'>No. of Credit Enquiries</p>
                            </div>
                        </div>

                        <div className='max-md:h-32 max-md:grid max-md:grid-cols-2 max-md:gap-4 md:flex gap-5'>
                            <div className='max-md:h-32 flex flex-col md:w-[200px] md:h-[150px] md:mt-[-12%] md:ml-[-4%] bg-white rounded-xl justify-center items-start p-6 md:p-10 gap-2'>
                                <img className='object-cover' src={Group692} alt="none" width={30} height={30} />
                                <p className='max-md:text-sm'>Payments History</p>
                            </div>
                            <div className='max-md:h-32 flex flex-col md:w-[180px] md:h-[130px] md:mt-[-3%] bg-white rounded-xl justify-center items-start p-6 md:p-10 gap-2'>
                                <img className='object-cover' src={Vector1} alt="none" width={30} height={30} />
                                <p className='max-md:text-sm'>Credit Mix</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p className='text-3xl text-center mt-[10%] max-md:mt-20 mb-4 md:mb-[2%]'>To know more details</p>
            <div className='flex justify-center items-center mb-16 md:mb-[3%]'>
                <Link to='/profile' className='w-full flex justify-center items-center'><button className='bg-primary hover:text-gray-200 rounded-2xl md:w-[15%] lg:w-[15%] w-[50%] md:h-[70px] h-14 text-white text-center max-md:text-sm max-md:px-2'>Get Free Cibil Score</button></Link>
            </div>
            <Faqs />
            <Footer />
            <p className='sr-only'>KGST</p>
        </div >

    )
}

export default CreditReport